import ClientAPI from '../ClientAPI'

const clientAPI = new ClientAPI()

const getCategoriesMenu = () => clientAPI.getCategories()

export default getCategoriesMenu
